{
  "el": {
    "countries": {
      "ABW": "Αρούμπα",
      "AFG": "Αφγανιστάν",
      "AFI": "Αφάρ και Ίσσας",
      "AGO": "Αγκόλα",
      "AIA": "Ανγκουίλα",
      "ALA": "Νησιά Ώλαντ",
      "ALB": "Αλβανία",
      "AND": "Ανδόρα",
      "ANT": "Ολλανδικές Αντίλλες",
      "ARE": "Ηνωμένα Αραβικά Εμιράτα",
      "ARG": "Αργεντινή",
      "ARM": "Αρμενία",
      "ASM": "Αμερικανική Σαμόα",
      "ATA": "Ανταρκτική",
      "ATB": "Βρετανικό Ανταρκτικό Έδαφος",
      "ATF": "Γαλλικά Νότια και Ανταρκτικά Εδάφη",
      "ATG": "Αντίγκουα και Μπαρμπούντα",
      "ATN": "Γη Βασίλισσας Μοντ",
      "AUS": "Αυστραλία",
      "AUT": "Αυστρία",
      "AZE": "Αζερμπαϊτζάν",
      "BDI": "Μπουρούντι",
      "BEL": "Βέλγιο",
      "BEN": "Μπενίν",
      "BES": "Μπονέρ, Άγιος Ευστάθιος και Σάβα",
      "BFA": "Μπουρκίνα Φάσο",
      "BGD": "Μπανγκλαντές",
      "BGR": "Βουλγαρία",
      "BHR": "Μπαχρέιν",
      "BHS": "Μπαχάμες",
      "BIH": "Βοσνία και Ερζεγοβίνη",
      "BLM": "Άγιος Βαρθολομαίος",
      "BLR": "Λευκορωσία",
      "BLZ": "Μπελίζ",
      "BMU": "Βερμούδες",
      "BOL": "Βολιβία",
      "BRA": "Βραζιλία",
      "BRB": "Μπαρμπάντος",
      "BRN": "Μπρουνέι",
      "BTN": "Μπουτάν",
      "BUR": "Βιρμανία",
      "BVT": "Νήσος Μπουβέ",
      "BWA": "Μποτσουάνα",
      "BYS": "Λευκορωσία",
      "CAF": "Κεντροαφρικανική Δημοκρατία",
      "CAN": "Καναδάς",
      "CCK": "Νήσοι Κόκος (Κίλινγκ)",
      "CHE": "Ελβετία",
      "CHL": "Χιλή",
      "CHN": "Κίνα",
      "CIV": "Ακτή Ελεφαντοστού",
      "CMR": "Καμερούν",
      "COD": "Κονγκό",
      "COG": "Κονγκό",
      "COK": "Νήσοι Κουκ",
      "COL": "Κολομβία",
      "COM": "Κομόρες",
      "CPV": "Πράσινο Ακρωτήριο",
      "CRI": "Κόστα Ρίκα",
      "CSK": "Τσεχοσλοβακία",
      "CTE": "Νήσοι Κάντον και Έντερμπερι",
      "CUB": "Κούβα",
      "CUW": "Κουρασάο",
      "CXR": "Νήσος Χριστουγέννων",
      "CYM": "Νήσοι Κέιμαν",
      "CYP": "Κύπρος",
      "CZE": "Τσεχία",
      "DDR": "Ανατολική Γερμανία",
      "DEU": "Γερμανία",
      "DHY": "Νταχομέι",
      "DJI": "Τζιμπουτί",
      "DMA": "Ντομίνικα",
      "DNK": "Δανία",
      "DOM": "Δομινικανή Δημοκρατία",
      "DZA": "Αλγερία",
      "ECU": "Ισημερινός",
      "EGY": "Αίγυπτος",
      "ERI": "Ερυθραία",
      "ESH": "Δυτική Σαχάρα",
      "ESP": "Ισπανία",
      "EST": "Εσθονία",
      "ETH": "Αιθιοπία",
      "FIN": "Φινλανδία",
      "FJI": "Φίτζι",
      "FLK": "Νήσοι Φώκλαντ (Μαλβίνες)",
      "FRA": "Γαλλία",
      "FRO": "Νήσοι Φερόε",
      "FSM": "Μικρονησία",
      "FXX": "Μητροπολιτική Γαλλία",
      "GAB": "Γκαμπόν",
      "GBR": "Ηνωμένο Βασίλειο",
      "GEL": "Νήσοι Γκίλμπερτ",
      "GEO": "Γεωργία",
      "GGY": "Γκέρνζι",
      "GHA": "Γκάνα",
      "GIB": "Γιβραλτάρ",
      "GIN": "Γουινέα",
      "GLP": "Γουαδελούπη",
      "GMB": "Γκάμπια",
      "GNB": "Γουινέα-Μπισάου",
      "GNQ": "Ισημερινή Γουινέα",
      "GRC": "Ελλάδα",
      "GRD": "Γρενάδα",
      "GRL": "Γροιλανδία",
      "GTM": "Γουατεμάλα",
      "GUF": "Γαλλική Γουιάνα",
      "GUM": "Γκουάμ",
      "GUY": "Γουιάνα",
      "HKG": "Χονγκ Κονγκ",
      "HMD": "Νήσος Χερντ και Νησιά Μακντόναλντ",
      "HND": "Ονδούρα",
      "HRV": "Κροατία",
      "HTI": "Αϊτή",
      "HUN": "Ουγγαρία",
      "HVO": "Άνω Βόλτα",
      "IDN": "Ινδονησία",
      "IMN": "Νήσος Μαν",
      "IND": "Ινδία",
      "IOT": "Βρετανικό Έδαφος Ινδικού Ωκεανού",
      "IRL": "Ιρλανδία",
      "IRN": "Ιράν",
      "IRQ": "Ιράκ",
      "ISL": "Ισλανδία",
      "ISR": "Ισραήλ",
      "ITA": "Ιταλία",
      "JAM": "Τζαμάικα",
      "JEY": "Τζέρσεϊ",
      "JOR": "Ιορδανία",
      "JPN": "Ιαπωνία",
      "JTN": "Νήσος Τζόνστον",
      "KAZ": "Καζακστάν",
      "KEN": "Κένυα",
      "KGZ": "Κιργιζία",
      "KHM": "Καμπότζη",
      "KIR": "Κιριμπάτι",
      "KNA": "Άγιος Χριστόφορος, Νέβις και Ανγκουίλα",
      "KOR": "Νότια Κορέα",
      "KWT": "Κουβέιτ",
      "LAO": "Λάος",
      "LBN": "Λίβανος",
      "LBR": "Λιβερία",
      "LBY": "Λιβύη",
      "LCA": "Αγία Λουκία",
      "LIE": "Λιχτενστάιν",
      "LKA": "Σρι Λάνκα",
      "LSO": "Λεσότο",
      "LTU": "Λιθουανία",
      "LUX": "Λουξεμβούργο",
      "LVA": "Λετονία",
      "MAC": "Μακάο",
      "MAF": "Άγιος Μαρτίνος (Γαλλικό τμήμα)",
      "MAR": "Μαρόκο",
      "MCO": "Μονακό",
      "MDA": "Μολδαβία",
      "MDG": "Μαδαγασκάρη",
      "MDV": "Μαλδίβες",
      "MEX": "Μεξικό",
      "MHL": "Νήσοι Μάρσαλ",
      "MID": "Νήσοι Μίντγουεϊ",
      "MKD": "Βόρεια Μακεδονία",
      "MLI": "Μάλι",
      "MLT": "Μάλτα",
      "MMR": "Μιανμάρ",
      "MNE": "Μαυροβούνιο",
      "MNG": "Μογγολία",
      "MNP": "Βόρειες Νήσοι Μαριάνες",
      "MOZ": "Μοζαμβίκη",
      "MRT": "Μαυριτανία",
      "MSR": "Μοντσερράτ",
      "MTQ": "Μαρτινίκα",
      "MUS": "Μαυρίκιος",
      "MWI": "Μαλάουι",
      "MYS": "Μαλαισία",
      "MYT": "Μαγιότ",
      "NAM": "Ναμίμπια",
      "NCL": "Νέα Καληδονία",
      "NER": "Νίγηρας",
      "NFK": "Νήσος Νόρφολκ",
      "NGA": "Νιγηρία",
      "NHB": "Νέες Εβρίδες",
      "NIC": "Νικαράγουα",
      "NIU": "Νιούε",
      "NLD": "Κάτω Χώρες",
      "NOR": "Νορβηγία",
      "NPL": "Νεπάλ",
      "NRU": "Ναουρού",
      "NTZ": "Ουδέτερη Ζώνη",
      "NZL": "Νέα Ζηλανδία",
      "OMN": "Ομάν",
      "PAK": "Πακιστάν",
      "PAN": "Παναμάς",
      "PCI": "Νήσοι Ειρηνικού (Εδαφική Κηδεμονία)",
      "PCN": "Πίτκερν",
      "PCZ": "Ζώνη Διώρυγας Παναμά",
      "PER": "Περού",
      "PHI": "Φιλιππίνες",
      "PHL": "Φιλιππίνες",
      "PLW": "Παλάου",
      "PNG": "Παπούα Νέα Γουινέα",
      "POL": "Πολωνία",
      "PRI": "Πουέρτο Ρίκο",
      "PRK": "Βόρεια Κορέα",
      "PRT": "Πορτογαλία",
      "PRY": "Παραγουάη",
      "PSE": "Παλαιστινιακό Έδαφος υπό Κατοχή",
      "PUS": "Διάφορες Νήσοι Ειρηνικού των ΗΠΑ",
      "PYF": "Γαλλική Πολυνησία",
      "QAT": "Κατάρ",
      "REU": "Ρεϋνιόν",
      "RHO": "Νότια Ροδεσία",
      "ROU": "Ρουμανία",
      "RUS": "Ρωσία",
      "RWA": "Ρουάντα",
      "SAU": "Σαουδική Αραβία",
      "SCG": "Σερβία και Μαυροβούνιο",
      "SDN": "Σουδάν",
      "SEN": "Σενεγάλη",
      "SGP": "Σιγκαπούρη",
      "SGS": "Νότια Γεωργία και Νότιες Νήσοι Σάντουιτς",
      "SHN": "Αγία Ελένη, Ασένσιον και Τριστάν ντα Κούνια",
      "SJM": "Σβάλμπαρντ και Γιαν Μαγιέν",
      "SKM": "Σικίμ",
      "SLB": "Νήσοι Σολομώντα",
      "SLE": "Σιέρα Λεόνε",
      "SLV": "Ελ Σαλβαδόρ",
      "SMR": "Άγιος Μαρίνος",
      "SOM": "Σομαλία",
      "SPM": "Άγιος Πέτρος και Μικελόν",
      "SRB": "Σερβία",
      "SSD": "Νότιο Σουδάν",
      "STP": "Σάο Τομέ και Πρίνσιπε",
      "SUN": "ΕΣΣΔ",
      "SUR": "Σουρινάμ",
      "SVK": "Σλοβακία",
      "SVN": "Σλοβενία",
      "SWE": "Σουηδία",
      "SWZ": "Σουαζιλάνδη",
      "SXM": "Σιντ Μάρτεν (Ολλανδικό τμήμα)",
      "SYC": "Σεϋχέλλες",
      "SYR": "Συρία",
      "TCA": "Νήσοι Τερκς και Κάικος",
      "TCD": "Τσαντ",
      "TGO": "Τόγκο",
      "THA": "Ταϊλάνδη",
      "TJK": "Τατζικιστάν",
      "TKL": "Τοκελάου",
      "TKM": "Τουρκμενιστάν",
      "TLS": "Ανατολικό Τιμόρ",
      "TMP": "Πορτογαλικό Τιμόρ",
      "TON": "Τόνγκα",
      "TTO": "Τρινιντάντ και Τομπάγκο",
      "TUN": "Τυνησία",
      "TUR": "Τουρκία",
      "TUV": "Τουβαλού",
      "TWN": "Ταϊβάν, Επαρχία της Κίνας",
      "TZA": "Τανζανία",
      "UGA": "Ουγκάντα",
      "UKR": "Ουκρανία",
      "UMI": "Απομακρυσμένες Μικρές Νήσοι των ΗΠΑ",
      "URY": "Ουρουγουάη",
      "USA": "Ηνωμένες Πολιτείες της Αμερικής",
      "UZB": "Ουζμπεκιστάν",
      "VAT": "Πόλη του Βατικανού",
      "VCT": "Άγιος Βικέντιος και Γρεναδίνες",
      "VDR": "Βόρειο Βιετνάμ",
      "VEN": "Βενεζουέλα",
      "VGB": "Βρετανικές Παρθένοι Νήσοι",
      "VIR": "Αμερικανικές Παρθένοι Νήσοι",
      "VNM": "Νότιο Βιετνάμ",
      "VUT": "Βανουάτου",
      "WAK": "Νήσος Γουέικ",
      "WLF": "Ουαλίς και Φουτούνα",
      "WSM": "Σαμόα",
      "XXX": "Άγνωστο",
      "YEM": "Βόρεια Υεμένη",
      "YMD": "Νότια Υεμένη",
      "YUG": "Γιουγκοσλαβία",
      "ZAF": "Νότια Αφρική",
      "ZAR": "Ζαΐρ",
      "ZMB": "Ζάμπια",
      "ZWE": "Ζιμπάμπουε"
    }
  }
}
